var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cadastro-section-label",class:("cadastro-section-label--" + _vm.variant)},[_c('span',{staticClass:"cadastro-section-label__text"},[_vm._v(_vm._s(_vm.label))]),_c('hr',{staticClass:"cadastro-section-label__divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }